/* eslint-disable */
export default {
  header: 'Contactar a assistência',
  toggleTitle: '1. Ative o modo de monitorização de erros',
  toggleDescription:
    'Isto vai ajudar-nos a localizar os seus problemas, mas pode afetar ligeiramente o desempenho da aplicação.',
  downloadTitle:
    '2. Transfira o registo de erros quando tiver reproduzido o problema',
  downloadButton: 'Transferir',
  downloadDisabledTitle:
    'Para poder transferir o registo de erros, primeiro tem de ativar o modo de monitorização de erros.',
  sendTitle: '3. Envie o registo à equipa de assistência',
  createSupportTicket: 'Crie um pedido de assistência',
  sendDescription:
    ' para entrar em contacto com a nossa equipa de assistência. Em seguida, envie o registo à equipa de assistência para a resolução de problemas.',
  privacyNotice:
    'Ao transferir e enviar-nos o registo, concorda em permitir que a RingCentral aceda a determinadas informações relacionadas com o registo com o objetivo de resolver problemas e processar erros. Para obter mais informações acerca de como a RingCentral processa dados pessoais, reveja os nossos ',
  privacyNoticeLink: 'Termos de serviço',
  and: ' e ',
  privacyNoticeEnd: 'Aviso de privacidade.',
  needLeavePage:
    'Pode sair desta página enquanto a monitorização de erros estiver em execução. Quando tiver reproduzido o problema, volte a esta página e transfira os ficheiros de registo.',
  downloading: 'A transferir',
} as const;

// @key: @#@"header"@#@ @source: @#@"Contact support"@#@
// @key: @#@"toggleTitle"@#@ @source: @#@"1. Turn on error tracking mode"@#@
// @key: @#@"toggleDescription"@#@ @source: @#@"This will help us locate your issues, but may slightly affect your app performance."@#@
// @key: @#@"downloadTitle"@#@ @source: @#@"2. Download the error log when you have replicated the issue."@#@
// @key: @#@"downloadButton"@#@ @source: @#@"Download"@#@
// @key: @#@"downloadDisabledTitle"@#@ @source: @#@"Turn on error tracking mode before you can download error log."@#@
// @key: @#@"sendTitle"@#@ @source: @#@"3. Send the log to support team"@#@
// @key: @#@"createSupportTicket"@#@ @source: @#@"Create a support ticket"@#@
// @key: @#@"sendDescription"@#@ @source: @#@" to get in touch with our support team. Then send the log to the support team for troubleshooting."@#@
// @key: @#@"privacyNotice"@#@ @source: @#@"By downloading and sending us the log, you agree to allow RingCentral to access certain log related information for troubleshooting and error handling purposes. For more information on how RingCentral processes personal data, please review our "@#@
// @key: @#@"privacyNoticeLink"@#@ @source: @#@"Terms of Service"@#@
// @key: @#@"and"@#@ @source: @#@" and "@#@
// @key: @#@"privacyNoticeEnd"@#@ @source: @#@"Privacy Notice."@#@
// @key: @#@"needLeavePage"@#@ @source: @#@"You may leave this page while error tracking is running. When you have replicated the issue, return to this page and download the log files."@#@
// @key: @#@"downloading"@#@ @source: @#@"Downloading"@#@
